import '@banno/jha-wc/src/forms/jha-form-switch/jha-form-switch';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmFormControl } from '../forms';

const tagName = 'tm-wc-switch';

@customElement(tagName)
class TmWcSwitch extends TmFormControl<boolean> {
    @property({ type: Boolean })
    public checked = false;

    @property({ type: Boolean })
    public disabled = false;

    @property({ type: Boolean })
    public async = false;

    protected validate(): boolean {
        return true;
    }

    protected render() {
        return html`<jha-form-switch
            .checked=${this.checked}
            .disabled=${this.disabled}
            ?async=${this.async}
        >
            <slot name="left-label" slot="left-label"></slot>
            <slot name="right-label" slot="right-label"></slot>
        </jha-form-switch>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmWcSwitch;
    }
}
